import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  TDiiaGetStatusRequest,
  TDiiaGetStatusResponse,
  TDiiaInitializeResponse,
} from '~/store/diia/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TBaseRequest } from '~/store/types';

export const initializeDiiaSignatureProcessingPersonal = createAsyncThunk<
  TDiiaInitializeResponse,
  TBaseRequest
>(
  'diia/diiaSignatureProcessingPersonalSubmit',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await api.get(
        `/personal-data/public/personal-data/applications/${applicationId}/diia-sign-initialize`,
        { headers }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const getStatusDiiaSignatureProcessingPersonal = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaGetStatusRequest
>(
  'diia/diiaGetStatusSignatureProcessingPersonalSubmit',
  async ({ applicationId, token, requestId }, { rejectWithValue, signal }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.get(
        `/personal-data/public/personal-data/applications/${applicationId}/diia-sign-get-status/${requestId}`,
        {
          headers,
          signal,
        }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const getFinalStatusDiiaSignatureProcessingPersonal = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaGetStatusRequest
>(
  'diia/diiaGetFinalStatusSignatureProcessingPersonalSubmit',
  async ({ applicationId, token, requestId }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.post(
        `/personal-data/public/personal-data/applications/${applicationId}/diia-sign-get-final-status/${requestId}`,
        null,
        { headers }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

// --------------------

export const revokeInitializeDiiaSignatureProcessingPersonal = createAsyncThunk<
  TDiiaInitializeResponse,
  TBaseRequest
>(
  'diia/diiaSignatureProcessingPersonalRevoke',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.get(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/diia-sign-initialize`,
        { headers }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const revokeGetStatusDiiaSignatureProcessingPersonal = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaGetStatusRequest
>(
  'diia/diiaGetStatusSignatureProcessingPersonalRevoke',
  async ({ applicationId, token, requestId }, { rejectWithValue, signal }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.get(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/diia-sign-get-status/${requestId}`,
        {
          headers,
          signal,
        }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const revokeGetFinalStatusDiiaSignatureProcessingPersonal = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaGetStatusRequest
>(
  'diia/diiaGetFinalStatusSignatureProcessingPersonalRevoke',
  async ({ applicationId, token, requestId }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await api.post(
        `/personal-data/public/personal-data/revoke/applications/${applicationId}/diia-sign-get-final-status/${requestId}`,
        null,
        { headers }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
